import AccountDetails from "./accountDetails"
import AcctDeleteReasons from './reasons'
import AcctDeleteOtherReasons from './otherReasons'
import OtpValidation from './otpValidation'
import AcctDeleteCompletion from './deleteCompletion'

export default [
    AccountDetails,
    AcctDeleteReasons,
    AcctDeleteOtherReasons,
    OtpValidation,
    AcctDeleteCompletion
]